export const confirmationRules = async (): Promise<void> => {
    // this is most likely not going to be used
};
